<template>
  <el-card>
    <div class="toolbar">
      <div class="former">
        <el-select v-model="former.Status" clearable placeholder="请选择工控机状态">
          <el-option label="在线" :value="1"></el-option>
          <el-option label="离线" :value="0"></el-option>
        </el-select>&nbsp;
        <el-input
          v-model="former['Name|Mn|Sn:like']"
          placeholder="名称，MN，SN等"
          @keydown.enter.native="onSubmitQuery"
        ></el-input>&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-fw fa-search"></i>
        </el-button>
      </div>
    </div>

    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * (pager.page)).toString().length * 12)"
      ></el-table-column>
      <el-table-column prop="Name" label="工控机名称"></el-table-column>
      <el-table-column prop="Sn" label="工控机编号"></el-table-column>
      <el-table-column prop="Sn" label="所在地"></el-table-column>
      <el-table-column prop="Status" label="硬件心跳" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.Status === 1">
            <div class="circle-h bg-success"></div>
          </span>
          <span v-else>
            <div class="circle-h bg-danger"></div>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="Sn" label="最新小时数据发送时间"></el-table-column>
      <el-table-column prop="Sn" label="最新分钟数据发送时间"></el-table-column>
      <el-table-column prop="Sn" label="今日已发数小时数据数">
        <template slot-scope="scope">
          <span>{{scope.row.Status}}/{{scope.row.Status}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Sn" label="昨日已发数小时数据数">
        <template slot-scope="scope">
          <span>{{scope.row.Status}}/{{scope.row.Status}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Status" label="是否过保" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.Status === 1">
            <div class="circle-h bg-success"></div>
          </span>
          <span v-else>
            <div class="circle-h bg-danger"></div>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="Sn" label="今日通知报警"></el-table-column>
      <el-table-column label="所属平台" width="120">
        <template slot-scope="scope">
          <el-tag
            width="120"
            v-for="platform in scope.row.Platforms"
            :key="platform.PlatformID"
            type="success"
            @close="onDeletePlatform(platform, scope.row)"
            closable
          >{{platform.PlatformName}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="100" label="操作">
        <template slot-scope="scope">
          <!-- <el-button
            size="mini"
            type="success"
            plain
            @click="onAddPlatform(scope.row)"
            title="绑定平台"
          >
            <i class="fas fa-plus"></i>
          </el-button> -->
          <el-button type="primary" @click.stop="onSeeItem(scope.row)" title="详情">
            <i class="fas fa-eye"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="paginator">
      <el-pagination
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <el-dialog
      title="选择所属平台"
      :visible.sync="platformVisible"
      width="400px"
      top="5vh"
      @close="platformData.platformId = ''"
      :close-on-click-modal="false"
    >
      <div class="clearfix">
        <div class="pull-left text-right pad-rgt" style="width: 75px; line-height: 30px;">选择平台：</div>
        <div style="margin-left: 90px;">
          <el-select v-model="platformData.platformId" placeholder="选择平台" style="width: 100%;">
            <!-- eslint-disable vue/no-use-v-if-with-v-for -->
            <el-option
              v-for="(item, index) in platformList"
              v-if="platformSelected.indexOf(item.ID) === -1"
              :value="item.ID"
              :label="item.Name"
              :key="index"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="platformVisible = false">
          <i class="fas fa-times"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onSaveJoinPlatform" :disabled="!platformData.platformId">
          <i class="far fa-save"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      itemList: [],
      former: {
        'Name|Mn|Sn:like': '',
        Status: '',
      },
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      loading: false,
      platformVisible: false,
      platformData: {
        ipcDeviceId: '',
        platformId: '',
      },
      platformList: [],
      platformSelected: [],
    };
  },
  mounted() {
    this.getItemList();
    this.getPlatformList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios.get('ipcdevice', {
        params: {
          where: _.omit(this.former),
          with: ['Platforms'],
          ...this.pager,
        },
      }).then((response) => {
        this.itemList = response.data.data;
        this.pager = _.pick(response.data, 'size', 'page', 'total');
        if (this.pager.page > response.data.last) {
          this.pager.page = response.data.last;
          this.getItemList();
        }
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      }).finally(() => {
        this.loading = false;
      });
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },

    onAddPlatform(row) {
      this.platformSelected = [];
      this.platformData.ipcDeviceId = row.ID;
      if (row.Platforms !== null) {
        row.Platforms.forEach((item) => {
          this.platformSelected.push(item.ID);
        });
      }
      this.platformVisible = true;
    },

    onSaveJoinPlatform() {
      const url = `ipcdevice/${this.platformData.ipcDeviceId}/platform/${this.platformData.platformId}`;
      this.$axios.post(url).then(() => {
        this.$message.success('添加成功');
        this.getItemList();
        this.platformVisible = false;
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },

    onDeletePlatform(platform, device) {
      const url = `ipcdevice/${device.ID}/platform/${platform.ID}`;
      this.$confirm('确定要删除此平台吗？', '提示').then(
        () => this.$axios.delete(url)
      ).then(() => {
        this.getItemList();
        this.$message.success('成功删除');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },

    getPlatformList() {
      this.$axios.get('platform').then((response) => {
        this.platformList = response.data.data;
        this.loading = false;
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
    onSeeItem() {
    },
  },
};
</script>

<style scoped lang="scss">
.circle-h {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
</style>
